  import { Component, OnInit, ViewEncapsulation,ViewChild, NgZone, DoCheck } from '@angular/core';
  import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
  import { ActivatedRoute, Router } from '@angular/router';
  import { ToastrService } from 'ngx-toastr';
  import { ApiService } from 'app/shared/services/api.service';
  import { Lms } from 'app/shared/models/lms';
  import { StrapiApiService } from 'app/shared/services/strapi-api.service';
import { Course } from 'app/shared/models/course.model';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
  @Component({
    selector: 'app-course-add-edit',
    templateUrl: './course-add-edit.component.html',
    styleUrls: ['./course-add-edit.component.scss','../../../../../../assets/sass/libs/select.scss'],
    encapsulation: ViewEncapsulation.None
  })
  export class CourseAddEditComponent implements OnInit ,DoCheck {
    activeTab = "basic";
    basicFormSubmitted = false;
    advanceFormSubmitted = false;
    pricingFormSubmitted = false;
    publishFormSubmitted = false;
    adminFormSubmitted = false;
    alertVisible = true;
    disabledStates:Record<string,boolean> = {
      title:true
    }
    countries = [
        { value: "USA", name: 'USA' },
        { value: "UK", name: 'UK'},
        { value: "Canada", name: 'Canada' },
    ];
  
    selectedLanguages:any = [];
    languages = [
        { value: "english", name: 'English' },
        { value: "hindi", name: 'Hindi'},
        // { value: "French", name: 'French' },
        // { value: "Russian", name: 'Russian' },
        // { value: "German", name: 'German'},
        // { value: "Hindi", name: 'Hindi' },
        // { value: "Arabic", name: 'Arabic' },
        // { value: "Sanskrit", name: 'Sanskrit'},
    ];
  
    selectedMusic = ["Jazz", "Hip Hop"];
    music = [
        { value: "Rock", name: 'Rock' },
        { value: "Jazz", name: 'Jazz'},
        { value: "Disco", name: 'Disco' },
        { value: "Pop", name: 'Pop' },
        { value: "Techno", name: 'Techno'},
        { value: "Folk", name: 'Folk' },
        { value: "Hip Hop", name: 'Hip Hop' },
    ];
  
    selectedMovies = ["The Dark Knight", "Perl Harbour"];
    movies = [
        { value: "Avatar", name: 'Avatar' },
        { value: "The Dark Knight", name: 'The Dark Knight'},
        { value: "Harry Potter", name: 'Harry Potter' },
        { value: "Iron Man", name: 'Iron Man' },
        { value: "Spider Man", name: 'Spider Man'},
        { value: "Perl Harbour", name: 'Perl Harbour' },
        { value: "Airplane!", name: 'Airplane!' },
    ];
    @ViewChild('vform') validationForm: FormGroup;
    courseForm:FormGroup;
     selectedValue:'';
     selectedCourseInterest:''
    tags=[];
    fileData:File;
    selectedCategory =null;
    categoryList=[]
    selectedTag:string[]=[]
    tagsList=[];
    selectedBatch=null
    batchList=[];
    variationList=[];
    selectedVariation=null
    selectedLms:string[]=[]
    courseTagsList=[];
    selectedCourseTag=null
    courseFormSubmitted:boolean=false;
    lmsData: Lms[]
    catId='6319d5025ab9e462a96cfbba'
    skillId='6319d3595ab9e462a96cfb06'
    durationId='631ad5d2ce5c666542591b40'
    courseTagId='631ad5b3ce5c666542591b3c'
    variationId='6532279427098beed312fab4'
    category_tags_list =[]
    selected_category_tags=null
  
    course_type_List =[
      {displayname:'Internal',_id:'internal'},
      {displayname:'External',_id:'external'},
    ]
    selected_course_type:any ='external'
    level_List =[
      {displayname:'Beginner',_id:'beginner'},
      {displayname:'Intermediate',_id:'intermediate'},
      {displayname:'Advanced',_id:'advanced'}
    ]
    selected_level:any ='beginner'
    mode_List =[]
    // selected_mode :string[]=[]
    selected_mode =null
    publish_List =[
      {displayname:'True',_id:true},
      {displayname:'False',_id:false},
    ]
    selected_publish_web ='true'
    selected_publish_app =null
    fullpart_employee_list=[]
    selected_instructor =null
    selected_proofread=null
    selected_publisher=null
    selected_last_publisher = null
    project_list=[]
    workon_id='644a5c52af0db342c32eeaf8'
    selected_project = null
    resource_list=[]
    selected_resource=null
    offers_list=[]
    selected_discount=null
    duration_List =[]
    selected_duration=null
    course_variant_id:any
    offers_category_id:any
    imgUrl: string | ArrayBuffer;
    courseId: any;
    isEdit: boolean;
    course_model:any= new Course

    @ViewChild('radioWebyes') radioWebyes
    @ViewChild('radioMobileyes') radioMobileyes


    isValue:any={
      title:null,
      about:null,
      preliminarye:null,
      benifits:null,
      learning_audience:null,
      outcome:null,
      objective:null,
      total_fees:null
    }
    imageBaseUrl = environment.apiUrls.course_imageUrl

    publish_category_list = []
    publish_tags_list =[]
    selected_publish_category = null
    selected_publish_tag = null
    meta_data: any = {
      meta_title: '',
      meta_keywords:'',
      meta_description: '',
      canonical: '',
      og_tags: {
        title: '',
        site_name: "Meander Training.",
        url: '',
        image: '',
        description: '',
        type:''
      }
    }
    constructor(private formBuilder: FormBuilder,
      public toastr: ToastrService,
      public apiService:ApiService,
      private strapiService: StrapiApiService,
      private activatedRoute: ActivatedRoute,private spinner: NgxSpinnerService,
      private route:Router, private ngZone: NgZone) {
        this.activatedRoute.queryParams
        .subscribe(async (params: any) => {
        if(params.id){
          this.isEdit=true;
          this.courseId=params.id
          this.getCourseById()
        }
        });
        this.getAllCategory()
        this.getTagByCategory()
        this.getSkillTagByCategory()
        this.getBatchTagBycategory()
        this.getDurationTagByCategory()
        this.getCourseTagByCategory()
        this.getLmsV1()
        this.getAllTags()
        this.getFullPartEmployee()
        this.getProjectList()
        this.getResourceList()
       }
    basicForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
      about: new FormControl('', [Validators.required]),
      preliminarye: new FormControl('', [Validators.required]),
    });
  
    advanceForm = new FormGroup({
      benifits: new FormControl('', [Validators.required]),
      learning_audience: new FormControl('', [Validators.required]),
      outcome: new FormControl('', [Validators.required]),
      objective: new FormControl('', [Validators.required]),
      promotional_video: new FormControl('', [Validators.required]),
      version: new FormControl('', [Validators.required]),
      grading: new FormControl("true", [Validators.required]),
      certification: new FormControl("true", [Validators.required]),
      live_projects: new FormControl('yes', [Validators.required]),
    });
  
    pricingForm = new FormGroup({
      total_fees: new FormControl(0, [Validators.required]),
      min_fees: new FormControl(0),
      max_fees: new FormControl(0),
      offer: new FormControl(''),
      serviceandoffer: new FormControl(''),
    });
    adminForm = new FormGroup({
      announcements: new FormControl(''),
      notes: new FormControl(''),
      admin_notes: new FormControl(''),
      max_fees: new FormControl(''),
      serviceandoffer: new FormControl(''),
      password: new FormControl('',[Validators.required]),
      write_password: new FormControl('',[Validators.required]),
    });
    publishingForm = new FormGroup({
      published_datetime: new FormControl('', [Validators.required]),
      published_web: new FormControl(false, [Validators.required]),
      published_app: new FormControl(false, [Validators.required]),
    });
    
  
    setActiveTab(tab) {
      this.activeTab = tab;
    }
  
    get bf() {
      return this.basicForm.controls;
    }
  
    get cpf() {
      return this.advanceForm.controls;
    }
  
    get pf() {
      return this.pricingForm.controls;
    }
    get pbf() {
      return this.publishingForm.controls;
    }
    get adf() {
      return this.adminForm.controls;
    }
    onBasicFormSubmit() {
      this.basicFormSubmitted = true;
      if (this.basicForm.invalid) {
        return;
      }
      this.activeTab='advance' 
    }
    onAdminFormSubmit(){
      this.adminFormSubmitted = true
      if (this.basicForm.invalid) {
        return;
      }
    }
    onAdvanceFormSubmit() {
      this.advanceFormSubmitted = true;
      if (this.advanceForm.invalid) {
        return;
      }
      this.activeTab='pricing'
    }
  
    onPricingFormSubmit() {
      this.pricingFormSubmitted = true;
      if (this.pricingForm.invalid) {
        return;
      }
      this.activeTab='publishing'
    }
  
    onPublishingFormSubmit() {
      if (this.publishingForm.invalid) {
        return;
      }
      this.activeTab='admin'
    }
    ngDoCheck(){
      const allValuesExist = (
        this.isValue?.title && this.isValue?.about && this.isValue?.preliminarye &&
        this.isValue?.benifits && this.isValue?.learning_audience &&
        this.isValue?.objective && this.isValue?.outcome &&
        this.isValue?.total_fees && this.selected_instructor &&
        this.selected_mode && this.selected_duration &&
        this.selected_course_type && this.selectedLanguages && this.selectedTag && this.selected_level && this.selected_mode
        );
    
      if (this.radioWebyes) {
        this.radioWebyes.nativeElement.disabled = !allValuesExist;
      }
      if (this.radioMobileyes) {
        this.radioMobileyes.nativeElement.disabled = !allValuesExist;
      }
     
    }
      ngOnInit(): void {
        this.course_model.grading ="true"
        this.course_model.certification ="true"
        this.course_model.live_projects ="yes"

        this.courseForm=this.formBuilder.group({
        title: ['', Validators.required],
        about: ['', Validators.required],
        preliminarye: ['', Validators.required],
        total_fees: ['', Validators.required],
        benifits: ['', Validators.required], 
        announcements: ['', Validators.required],
        image: ['', Validators.required],
        notes:['', ],
        admin_notes:['', ],
        learning_audience:['', ],
        outcome:['', ],
        objective:['', ],
        min_fees:['', ],
        max_fees:['', ],
        serviceandoffer:['',],
        grading:['', ],
        certification:['', ],
        published_datetime:['', ],
        version:['', ],
        language:['', ],
        promotional_video:['',],

      })
      this.basicForm.get('title').valueChanges.subscribe(value => {
        this.isValue.title = value
      });
      this.basicForm.get('about').valueChanges.subscribe(value => {
        this.isValue.about = value
      });
      this.basicForm.get('preliminarye').valueChanges.subscribe(value => {
        this.isValue.preliminarye = value
      });
      this.advanceForm.get('benifits').valueChanges.subscribe(value => {
        this.isValue.benifits = value
      });
      this.advanceForm.get('learning_audience').valueChanges.subscribe(value => {
        this.isValue.learning_audience = value
      });
      this.advanceForm.get('outcome').valueChanges.subscribe(value => {
        this.isValue.outcome = value
      });
      this.advanceForm.get('objective').valueChanges.subscribe(value => {
        this.isValue.objective = value
      });
     
      this.pricingForm.get('total_fees').valueChanges.subscribe(value => {
        this.isValue.total_fees = value
      });
    }
   
    getAllCategory(){
      this.apiService.getAllCategory(1, 1000).subscribe((res: any) => {
        let mode = res?.data?.items?.filter((item) => item.name == 'learningmode')
        if (mode) {
          this.apiService.getTagByTagCatgoryId(mode[0]._id).subscribe((res: any) => {
          this.mode_List = res.data;
          });
        }
        this.publish_category_list = res?.data?.items
        this.publish_category_list = res?.data?.items.filter(
        (item) =>item.name == "Internal Program"||item.name == "academicprogram"||item.name == "industrial_program" || item.name =="certification_program");
      
      this.publish_category_list.sort((a, b) => {
        if (a.displayname < b.displayname) {
          return -1;
        }
        if (a.displayname > b.displayname) {
          return 1;
        }
        return 0;
      });
          let course_variant = res?.data?.items.filter(item =>item.name =='course_variant')
          this.course_variant_id = course_variant[0]?._id
          let offers_category = res?.data?.items.filter(item =>item.name =='offers_category')
          this.offers_category_id =  offers_category[0]?._id
          if(this.course_variant_id){
            this.getVariationTagByCategory()
          }
          if(this.offers_category_id){
            this.getOfferslist()
          }
        })
      }
      getFullPartEmployee(){
        this.apiService.getFullPartEmployeeList(1,100).subscribe((res:any)=>{
          this.fullpart_employee_list = res?.items
        })
      }
      getProjectList(){
        this.apiService.getJobsByStatus('6428038677a2ab2fb559dc36',1,100,this.workon_id,'current').subscribe((res:any)=>{
          this.project_list=res.data.items
        })
      }
      getResourceList() {
        this.apiService.getResourceList( 1, 100).subscribe((res: any) => {
          this.resource_list = res?.items
        })
      }
      getOfferslist(){
        this.apiService.getTagByTagCatgoryId(this.offers_category_id).subscribe((res: any) => {
          this.offers_list = res?.data
        })
      }
      getAllTags(){
        this.apiService.getTagsList(1,500).subscribe((res:any)=>{
          this.category_tags_list = res?.data?.items
        })
      }
      getCategoryTagsId(event){
        this.selected_category_tags
      }
      getLmsV1() {
         this.strapiService.getLmsV1('').subscribe((res: any) => {
           this.lmsData = res;
         })
       }
       getLmsV1ById(event:any){
        this.selectedLms
       }
      
      getTagByCategory(){
        this.apiService.getTagByTagCatgoryId(this.catId).subscribe((res:any)=>{
          this.categoryList=res.data
        })
       }
       getCategoryId(event:any){
        this.selectedCategory
       }
       getSkillTagByCategory(){
        this.apiService.getTagByTagCatgoryId(this.skillId).subscribe((res:any)=>{
          this.tagsList=res.data
        })
       }
       getTagsId(event:any){
        this.selectedTag
      }
      getBatchTagBycategory(){
        this.apiService.getBatchList(1,100).subscribe((res:any)=>{
          this.batchList=res?.data?.items
        })
       }
       getBatchId(event:any){
        this.selectedBatch
       }
       getDurationTagByCategory(){
        this.apiService.getTagByTagCatgoryId(this.durationId).subscribe((res:any)=>{
          this.duration_List=res?.data
        })
       }
       getVariationTagByCategory(){
        this.apiService.getTagByTagCatgoryId(this.course_variant_id).subscribe((res: any) => {
          this.variationList = res?.data
        })
       }
       getVariationId(event:any){
        this.selectedVariation
       }
       getCourseTagByCategory(){
        this.apiService.getTagByTagCatgoryId(this.courseTagId).subscribe((res:any)=>{
          this.courseTagsList=res.data
        })
       }
       getCourseTagId(event:any){
        this.selectedCourseTag
       }
      get rf() {
        return this.courseForm.controls;
      }
     
      submitCourse(){
        let formData:FormData=new FormData()
       if(!this.courseId){
         
          if(this.selectedTag){
            this.selectedTag.forEach((course_skills, index) => {
              formData.append(`course_skills[${index}]`, course_skills);
            });
          }
         if(this.selectedLms){
          this.selectedLms.forEach((lsm_ids, index) => {
            formData.append(`lsm_ids[${index}]`, lsm_ids);
          });
         }
         

        this.basicForm.get('about').valueChanges.subscribe(value => {});
        this.advanceForm.get('learning_audience').valueChanges.subscribe(value => {});
        this.basicForm.get('preliminarye').valueChanges.subscribe(value => {});
        this.advanceForm.get('benifits').valueChanges.subscribe(value => {});
        this.advanceForm.get('learning_audience').valueChanges.subscribe(value => {});
        this.advanceForm.get('objective').valueChanges.subscribe(value => {});
        this.advanceForm.get('outcome').valueChanges.subscribe(value => {});
        this.pricingForm.get('serviceandoffer').valueChanges.subscribe(value => {});
        this.adminForm.get('announcements').valueChanges.subscribe(value => {});
        this.adminForm.get('notes').valueChanges.subscribe(value => {});
        this.adminForm.get('admin_notes').valueChanges.subscribe(value => {});

        formData.append('title',this.basicForm.value.title),
        formData.append('about',this.basicForm.value.about),
        formData.append('preliminary',this.basicForm.value.preliminarye),
        formData.append('course_type',this.selected_course_type)
        
        if(this.selected_mode){
          this.selected_mode.forEach((mode, index) => {
            formData.append(`course_mode[${index}]`, mode);
          });
        }
        formData.append('duration',this.selected_duration)
        if(this.selectedLanguages){
          this.selectedLanguages.forEach((language, index) => {
            formData.append(`language[${index}]`, language);
          });
        }
        formData.append('course_category',this.selectedCategory),
        formData.append('variations',this.selectedVariation),

        formData.append('benifits',this.advanceForm.value.benifits),
        formData.append('learning_audience',this.advanceForm.value.learning_audience),
        formData.append('objective',this.advanceForm.value.objective),
        formData.append('outcome',this.advanceForm.value.outcome)
        if(this.selected_project){
          this.selected_project.forEach((projects, index) => {
            formData.append(`projects[${index}]`, projects);
          });
        }
        formData.append('promotional_video',this.advanceForm.value.promotional_video),
        formData.append('level',this.selected_level)
        if(this.selected_resource){
          this.selected_resource.forEach((resources, index) => {
            formData.append(`resources[${index}]`, resources);
          });
        }
        formData.append('grading',this.advanceForm.value.grading),
        formData.append('certification',this.advanceForm.value.certification),
        formData.append('live_projects',this.advanceForm.value.live_projects),
        formData.append('version',this.advanceForm.value.version),
        formData.append('total_fees',this.pricingForm.value.total_fees),
        formData.append('minfees',this.pricingForm.value.min_fees),
        formData.append('maxfees',this.pricingForm.value.max_fees),
        formData.append('serviceandoffer',this.pricingForm.value.serviceandoffer),
        formData.append('offer',this.pricingForm.value.offer),
        formData.append('published_datetime',this.publishingForm.value.published_datetime),
        formData.append('published_web',this.publishingForm.value.published_web),
        formData.append('published_app',this.publishingForm.value.published_app)
        if(this.selectedCourseTag){
          this.selectedCourseTag.forEach((course_tags, index) => {
            formData.append(`course_tags[${index}]`, course_tags);
          });
        }
        if(this.selected_category_tags){
          this.selected_category_tags.forEach((category, index) => {
            formData.append(`category[${index}]`, category);
          });
        }
        if (this.selected_publish_category) {
          formData.append('publish_category',this.selected_publish_category)
         }
        if (this.selected_publish_tag) {
          formData.append('publish_tag',this.selected_publish_tag)
        }
        if(this.selected_instructor){
          this.selected_instructor.forEach((instructor, index) => {
            formData.append(`instructor[${index}]`, instructor);
          });
        }
        if(this.selected_proofread){
          this.selected_proofread.forEach((proofreaders, index) => {
            formData.append(`proofreaders[${index}]`, proofreaders);
          });
        }
        if(this.selected_publisher){
          this.selected_publisher.forEach((publishers, index) => {
            formData.append(`publishers[${index}]`, publishers);
          });
        }
        formData.append('last_published_by',this.selected_last_publisher),
        formData.append('batch_ids',this.selectedBatch),
        formData.append('announcements',this.adminForm.value.announcements),
        formData.append('notes',this.adminForm.value.notes),
        formData.append('admin_notes',this.adminForm.value.admin_notes)
        if (this.adminForm.value.password){
          formData.append('password',this.adminForm.value.password)
        } 
        if (this.adminForm.value.write_password){
          formData.append('write_password',this.adminForm.value.write_password)
        }
        formData.append('image',this.fileData),
         this.apiService.createCourse(formData).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success('Create Successfully',res.message)
           this.route.navigate(['/course/course-list']) 
          } 
          else{this.toastr.error(res.error)}  
         })
       
         this.courseFormSubmitted = true;
         if (this.courseForm.invalid) {
           return;
         }
       }
// ===========================
         if(this.courseId){
          this.selectedTag.forEach((course_skills, index) => {
            formData.append(`course_skills[${index}]`, course_skills);
          });
          this.selectedLms.forEach((lsm_ids, index) => {
            formData.append(`lsm_ids[${index}]`, lsm_ids);
          });

        formData.append('title',this.course_model.title),
        formData.append('about',this.course_model.about),
        formData.append('preliminary',this.course_model.preliminary),
        formData.append('course_type',this.selected_course_type),
        this.selected_mode.forEach((mode, index) => {
          formData.append(`course_mode[${index}]`, mode);
        });
        formData.append('duration',this.selected_duration),
        this.selectedLanguages.forEach((language, index) => {
          formData.append(`language[${index}]`, language);
        });
        formData.append('course_category',this.selectedCategory),
        formData.append('variations',this.selectedVariation),
        formData.append('benifits',this.course_model.benifits),
        formData.append('learning_audience',this.course_model.learning_audience),
        formData.append('objective',this.course_model.objective),
        formData.append('outcome',this.course_model.outcome),
        this.selected_project.forEach((projects, index) => {
          formData.append(`projects[${index}]`, projects);
        });
        formData.append('promotional_video',this.course_model.promotional_video),
        formData.append('level',this.selected_level),
        this.selected_resource.forEach((resources, index) => {
          formData.append(`resources[${index}]`, resources);
        });
        formData.append('grading',this.course_model.grading),
        formData.append('certification',this.course_model.certification),
        formData.append('live_projects',this.course_model.live_projects),
        formData.append('version',this.course_model.version),
        formData.append('total_fees',this.course_model.total_fees),
        formData.append('minfees',this.course_model.minfees),
        formData.append('maxfees',this.course_model.maxfees),
        formData.append('serviceandoffer',this.course_model.serviceandoffer),
        formData.append('offer',this.course_model.offer),
        formData.append('published_datetime',this.course_model.published_datetime),
        formData.append('published_web',this.course_model.published_web),
        formData.append('published_app',this.course_model.published_app),
        this.selectedCourseTag.forEach((course_tags, index) => {
          formData.append(`course_tags[${index}]`, course_tags);
        });
        this.selected_category_tags.forEach((category, index) => {
          formData.append(`category[${index}]`, category);
        });
        if (this.selected_publish_category) {
          formData.append('publish_category',this.selected_publish_category)
         }
        if (this.selected_publish_tag) {
          formData.append('publish_tag',this.selected_publish_tag)
        }
        this.selected_instructor.forEach((instructor, index) => {
          formData.append(`instructor[${index}]`, instructor);
        });
        this.selected_proofread.forEach((proofreaders, index) => {
          formData.append(`proofreaders[${index}]`, proofreaders);
        });
        this.selected_publisher.forEach((publishers, index) => {
          formData.append(`publishers[${index}]`, publishers);
        });
        formData.append('last_published_by',this.selected_last_publisher),
        formData.append('batch_ids',this.selectedBatch),
        formData.append('announcements',this.course_model.announcements),
        formData.append('notes',this.course_model.notes),
        formData.append('admin_notes',this.course_model.admin_notes)
        if (this.course_model.password){
          formData.append('password',this.course_model.password)
        } 
        if (this.course_model.write_password){
          formData.append('write_password',this.course_model.write_password)
        }
          formData.append('image', this.fileData),
        // =-====
        formData.append('meta_title: ',this.meta_data.meta_title),
        formData.append('meta_keywords',this.meta_data.meta_keywords),
        formData.append('meta_description',this.meta_data.meta_description),
        formData.append('canonical',this.meta_data.canonical),
        formData.append('og_tags.title', this.meta_data.og_tags.title)
        formData.append('og_tags.description',this.meta_data.og_tags.description)
        formData.append('og_tags.image',this.meta_data.og_tags.image)
        formData.append('og_tags.url', this.meta_data.og_tags.url)
        formData.append('og_tags.site_name', this.meta_data.og_tags.site_name)
        formData.append('og_tags.type',this.meta_data.og_tags.type)
           
        this.updateMetaInfo()
           
        this.apiService.updateCourse(this.courseId,formData).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success('update Successfully',res.message)
           this.route.navigate(['/course/course-list']) 
          } 
          else{this.toastr.error(res.error)}  
         })
      }
    
    }
    
    onSelectFile(event:any){
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        this.fileData = event.target.files[0];
        reader.readAsDataURL(event.target.files[0]);
        reader.onload=(event)=>{
          this.imgUrl=reader.result
        }
      }
    }
    resetFile(){
      this.fileData=null
      this.imgUrl=null
    }
    back(){
    this.route.navigate(['/course/course-list'])    
    } 
    getCourseTypeId(event){
      this.selected_course_type
    }
    getLevelId(event){
      this.selected_level
    }
    getModeId(event){
      this.selected_mode
    }
    getPublishWebId(event){
      this.selected_publish_web
    }
    getPublishAppId(event){
      this.selected_publish_app
    }
    getinstructorId(event){
      this.selected_instructor
    }
    getProofreadId(event){
      this.selected_proofread
    }
    getPublisherId(event){
      this.selected_publisher
    }
    getLastPublisherId(event){
      this.selected_last_publisher
    }
    getProjectId(event){
      this.selected_project
    }
    getResourceId(event){
      this.selected_resource
    }
    getDiscountId(event){
      this.selected_discount
    }
    getDurationId(event){
      this.selected_duration
    }
    getCourseById(){
      this.apiService.getCourseById(this.courseId).subscribe((res:any)=>{
        this.course_model = res?.data[0]
        this.fileData =  res?.data[0]?.image

        if(this.course_model.course_type){
          this.selected_course_type =  this.course_model.course_type
        }
        if(this.course_model.language){
          this.selectedLanguages = this.course_model.language.map(item=>item)
        }
        if(this.course_model.course_mode){
          this.selected_mode = this.course_model.course_mode.map(item=>item._id)
        }
        if(this.course_model.duration){
          this.selected_duration =  this.course_model.duration[0]?._id
        }
        if(this.course_model.course_category){
        this.selectedCategory = this.course_model.course_category[0]?._id
        }
        if(this.course_model.course_skills){
        this.selectedTag = this.course_model.course_skills.map((item:any)=>item?._id)
        }
        if(this.course_model.variations){
        this.selectedVariation  = this.course_model.variations[0]?._id
        }
        if(this.course_model.projects){
        this.selected_project =   this.course_model.projects.map((item:any)=>item?._id)
        }
        if(this.course_model.resources){
        this.selected_resource =   this.course_model.resources.map((item:any)=>item?._id)
        }
        if(this.course_model.level){
        this.selected_level =   this.course_model.level
        }
        if(this.course_model.course_tags){
        this.selectedCourseTag =  this.course_model.course_tags.map((item:any)=>item?._id)
        }
        if(this.course_model.category){
        this.selected_category_tags =  this.course_model.category.map((item:any)=>item?._id)
        }
        if(this.course_model.publish_category){
          this.selected_publish_category = this.course_model.publish_category
          this.getTagsByPublishCategory(this.selected_publish_category)

        }
        if(this.course_model.publish_tag){
        this.selected_publish_tag =  this.course_model.publish_tag
        }
        if(this.course_model.instructor){
        this.selected_instructor = this.course_model.instructor.map((item:any)=>item?._id)
        }
        if(this.course_model.proofreaders){
        this.selected_proofread = this.course_model.proofreaders.map((item:any)=>item?._id)
        }
        if(this.course_model.publishers){
        this.selected_publisher = this.course_model.publishers.map((item:any)=>item?._id)
        }
        if(this.course_model.last_published_by[0]){
        this.selected_last_publisher = this.course_model.last_published_by[0]._id
        }
        if(this.course_model.batch_ids){
        this.selectedBatch = this.course_model.batch_ids[0]?._id
        }
        this.meta_data.meta_title = res?.data[0]?.meta_title
        this.meta_data.meta_description = res?.data[0]?.meta_description
        this.meta_data.meta_keywords = res?.data[0]?.meta_keywords
        this.meta_data.canonical = res?.data[0]?.canonical
        this.meta_data.og_tags.title = res?.data[0]?.og_tags.title 
        this.meta_data.og_tags.description = res?.data[0]?.og_tags.description 
        this.meta_data.og_tags.type = res?.data[0]?.og_tags.type 
        this.meta_data.og_tags.image = res?.data[0]?.og_tags.image 
        this.meta_data.og_tags.url = res?.data[0]?.og_tags.url 
      })
     
    }

    getPublishCategoryId(event) {
      this.selected_publish_category
      if (this.selected_publish_category) {
        this.getTagsByPublishCategory(this.selected_publish_category)
      }
    }
     getPublishTagId(event) {
      this.selected_publish_tag
    }
    getTagsByPublishCategory(id) {
      this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
         if (res.data[0].name == "Employee Compliance") {
          this.publish_tags_list = res.data.filter((item) => item.name == "Employee Compliance"||item.name == "Student Guidelines");
        }
        else this.publish_tags_list = res.data;
        })
    }
    addMeta(id) {
      if (id) {
        this.spinner.show(undefined, {
          type: "ball-triangle-path",
          size: "medium",
          bdColor: "rgba(0, 0, 0, 0.8)",
          color: "#fff",
          fullScreen: true,
        });
        this.apiService.addcourseMeta(id).subscribe((res: any) => {
          if (res?.statusCode == 200) {
            this.spinner.hide()
            this.meta_data.meta_title = res?.data?.title
            this.meta_data.meta_keywords = res?.data?.meta_keywords
            this.meta_data.meta_description = res?.data?.meta_description
            this.meta_data.canonical = `https://meander.training/course-details/${this.course_model.slug}`
            let  modifiedOgTags:any = {}
            for (let key in res?.data?.og_tags) {
              if (res?.data?.og_tags.hasOwnProperty(key)) {
                  const newKey = key.replace('og:', '');
                  modifiedOgTags[newKey] = res?.data?.og_tags[key];
              }
            }
            this.meta_data.og_tags.title = modifiedOgTags?.title
            this.meta_data.og_tags.description = modifiedOgTags?.description
            this.meta_data.og_tags.type = modifiedOgTags?.type
            this.meta_data.og_tags.url = `https://meander.training/course-details/${this.course_model.slug}`
            this.meta_data.og_tags.image = `https://meandersoftware.s3.amazonaws.com/${this.course_model.image}`
          }
          else {
            this.toastr.error(res?.message)
          }
        })
      }
   }
   updateMetaInfo(){
    let body={
      meta_title: this.meta_data.meta_title,
      meta_keywords: this.meta_data.meta_keywords,
      meta_description: this.meta_data.meta_description,
      canonical: this.meta_data.canonical,
      og_title: this.meta_data.og_tags.title ,
      og_site_name: this.meta_data.og_tags.title ,
      og_type: this.meta_data.og_tags.type,
      og_url: this.meta_data.og_tags.url ,
      og_image: this.meta_data.og_tags.image,
      og_description: this.meta_data.og_tags.description
    }
    this.apiService.updateSeoData(this.courseId, body).subscribe((res: any) => {
      if (res?.statusCode == 200) {
        this.spinner.hide();
        this.toastr.success('Updated successfully');
      }
    })
   }
    
}
  
